import BasicField from './basic'

export default class DevelopmentField extends BasicField {
  value() {
    return this.body
  }
}
